import { useField } from 'formik';
import { ticketFieldLabelClass } from '../core/_utils';
import TicketFieldHint from './TicketFieldHint';

type Props = {
  name: string;
  label: string;
  placeholder?: string;
  multiline?: boolean;
  required?: boolean;
  help?: string;
};

const TicketTextField = ({ name, label, placeholder, multiline = false, required = false, help }: Props) => {
  const [field, meta] = useField(name);
  const labelClass = ticketFieldLabelClass(required);
  const id = `ticket-${name}`;
  const error = meta.touched ? meta.error : undefined;

  return (
    <div className="mb-5">
      <label className={labelClass} htmlFor={id}>
        {label}
      </label>
      {multiline ? (
        <textarea className="form-control form-control-solid" id={id} placeholder={placeholder} rows={3} {...field} />
      ) : (
        <input className="form-control form-control-solid" id={id} placeholder={placeholder} {...field} />
      )}
      <TicketFieldHint error={error} help={help} />
    </div>
  );
};

export default TicketTextField;
